/* eslint-disable react/prop-types */
import React from "react";

const RadioInput = ({
  name,
  id,
  value,
  checked,
  onChange,
  label,
  className = "",
  labelClassName = "",
}) => {
  return (
    <label className={`flex items-center space-x-1 ${labelClassName}`}>
      <input
        type="radio"
        name={name}
        id={(id ? id : name)}
        value={value}
        checked={checked}
        onChange={onChange}
        className={`form-radio ${className}`}
      />
      <span>{label}</span>
    </label>
  );
};

export default RadioInput;